import { render, staticRenderFns } from "./DropdownResourceSelector.vue?vue&type=template&id=716f0d54&scoped=true&"
import script from "./DropdownResourceSelector.vue?vue&type=script&lang=js&"
export * from "./DropdownResourceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716f0d54",
  null
  
)

export default component.exports